function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { sizes, colors, breakpoints } from './export';
/**
 * Настройки цветовой палитры для UI компонентов
 * @type {Object}
 */

var FLOATS = ['left', 'right'];
var TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
var VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];
var VISIBILITY = ['mobile', 'tablet', 'computer', 'large screen', 'widescreen'];
var WIDTHS = [];
export var UI = {
  COLORS: colors.colors,
  THEME_COLORS: colors.themeColors,
  SOCIAL_COLORS: colors.socialColors,
  SIZES: sizes,
  BREAKEPOINTS: breakpoints,
  FLOATS: FLOATS,
  TEXT_ALIGNMENTS: TEXT_ALIGNMENTS,
  VERTICAL_ALIGNMENTS: VERTICAL_ALIGNMENTS,
  VISIBILITY: VISIBILITY,
  WIDTHS: WIDTHS
  /**
   * Returns a createElement() type based on the props of the Component.
   * Useful for calculating what type a component should render as.
   *
   * @param {function} Component A function or ReactClass.
   * @param {object} props A ReactElement props object
   * @param {function} [getDefault] A function that returns a default element type.
   * @returns {string|function} A ReactElement type
   */

};
export function getElementType(Component, props, getDefault) {
  var _Component$defaultPro = Component.defaultProps,
      defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro; // ----------------------------------------
  // user defined "as" element type

  if (props.as && props.as !== defaultProps.as) return props.as; // ----------------------------------------
  // computed default element type

  if (getDefault) {
    var computedDefault = getDefault();
    if (computedDefault) return computedDefault;
  } // ----------------------------------------
  // infer anchor links


  if (props.href) return 'a'; // ----------------------------------------
  // use defaultProp or 'div'

  return defaultProps.as || 'div';
}
/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */

export var getUnhandledProps = function getUnhandledProps(Component, props) {
  return Object.keys(props).reduce(function (acc, prop) {
    if (prop === 'childKey') return acc;
    if (!Component.propTypes[prop]) acc[prop] = props[prop];
    return acc;
  }, {});
};
/* Хэлпер для вывода списков */

export var list = function list() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var Item = arguments.length > 1 ? arguments[1] : undefined;
  var key = arguments.length > 2 ? arguments[2] : undefined;
  var props = arguments.length > 3 ? arguments[3] : undefined;
  return data.map(function (item, index) {
    return React.createElement(Item, _extends({}, item, props, {
      key: item[key] || item.id || index
    }));
  });
};